export class LogVersaoModel {
    constructor(
        public id: number = 0,
        public sistema: number = 0,
        public descricao: string = '',
        public alteracoes: string = '',
        public data_estavel: string = '',
        public data_alfa: string = '',
        public data_beta: string = '',
        public obrigatorio: boolean = false,
        public situacao: number = 0,
        public versao: number = 0,
        public tipo_ambiente: number = 0,
    ) { }
}